export default "__VITE_ASSET__27618c9e__"